import React, { forwardRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import { ToastContainer, toast } from "react-toastify";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaMicrophone,
  FaMusic,
  FaDrum,
} from "react-icons/fa";
import Modal from "../Components/Popup/Popup";
import { MdEqualizer } from "react-icons/md";
import { GiGuitarBassHead } from "react-icons/gi";
import { PiGuitarFill } from "react-icons/pi";
import style from "../Components/Popup/Popup.css";

import {
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Button, Card } from "react-bootstrap";
import axios from "../Components/Axios/Axios";
import axios1 from "axios";
// Custom Components Import
import Loader from "../Components/Spinner/Spinner";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
import requests from "../Components/Requests/Requests";
import { InputAdornment } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";

// ---- Rows-per-page choices for the feedback table (kept in sync with the
// backend's ALLOWED_PAGE_SIZES whitelist in getfeedback1) ----
const PAGE_SIZE_OPTIONS = [30, 60, 90, 120];

// ---- Allowed file extensions for the "File Type" filter dropdown ----
const ALLOWED_EXTENSIONS = [
  "wav",
  "mp3",
  "ogg",
  "mp4",
  "m4a",
  "flac",
  "com",
  "org",
  "in",
  "me",
  "fm",
  "cc",
  "aac",
  "mov",
  "webm",
  "mpeg",
  "mp2",
  "3gp",
  "avi",
  "mkv",
  "wma",
  "m4v",
  "flv",
  "3gp2",
  "aiff",
  "test",
];

const StarRating = ({ rating }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const halfStars = rating % 1 >= 0.5 ? 1 : 0;
  const emptyStars = 5 - fullStars - halfStars;

  for (let i = 0; i < fullStars; i++) {
    stars.push(<FaStar key={`full-${i}`} color="#FFD700" />);
  }
  for (let i = 0; i < halfStars; i++) {
    stars.push(<FaStarHalfAlt key={`half-${i}`} color="#FFD700" />);
  }
  // for (let i = 0; i < emptyStars; i++) {
  //   stars.push(<FaRegStar key={`empty-${i}`} color="#FFD700" />);
  // }

  return <div>{stars}</div>;
};

const useStyles = makeStyles(() => ({
  noBorder: {
    border: "none",
    borderRadius: "5px",
  },
}));

function AllBlogs() {
  const [openmodal, setOpenModal] = useState(false);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0); // MaterialTable uses 0-based page indexing
  const [pageSize, setPageSize] = useState(30); // rows per page, one of PAGE_SIZE_OPTIONS
  const [totalCount, setTotalCount] = useState(0); // Total count of entries
  const [searchValue, setSearchValue] = useState("");
  const [karoakeData, setKaroakeData] = useState([]);
  const [currentBucket, setCurrentBucket] = useState(0);
  const [currentFileid, setCurrentFileid] = useState(0);

  // ---- Export all state ----
  const [exportingAll, setExportingAll] = useState(false);

  // ---- Filter state ----
  const [filters, setFilters] = useState({
    rating: "",
    platform: "",
    appversion: "",
    country: "",
    language: "",
    fromDate: "",
    toDate: "",
    user_id: "",
    requestId: "",
    requestIdEmpty: "", // "" | "yes" | "no"
    noteEmpty: "", // "" | "yes" | "no"
    aiNoteEmpty: "", // "" | "yes" | "no"
    extension: "", // file type / extension
  });

  // ---- Filter dropdown options (from API) ----
  const [appVersionOptions, setAppVersionOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  // File Type options: full allowed list by default, narrowed to the
  // selected rating's actual extensions once a rating filter is chosen.
  const [extensionOptions, setExtensionOptions] = useState(ALLOWED_EXTENSIONS);
  const [loadingExtensions, setLoadingExtensions] = useState(false);

  // ---- Edit Note state ----
  const [editNote, setEditNote] = useState({
    open: false,
    id: null,
    value: "",
  });
  const [savingNote, setSavingNote] = useState(false);

  // ---- Edit AI Note state (Ai Team Feedback -> audio_info.ai_note, sent with ai=1) ----
  const [editAiNote, setEditAiNote] = useState({
    open: false,
    id: null,
    value: "",
  });
  const [savingAiNote, setSavingAiNote] = useState(false);

  const tableIcons = {
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  useEffect(() => {
    // Fetch data whenever the page or rows-per-page changes
    if (searchValue === "") {
      fetchData(page + 1, filters); // Fetch data for the current page, respecting active filters
    } else {
      fetchDataSearch(searchValue, page + 1); // Fetch search data for the current page
    }
  }, [page, pageSize]); // Triggered when page or pageSize changes

  const handleDownload = (rowData, filename, is_aws_storage) => {
    console.log(rowData, "rowdata");
    if (rowData.is_aws_storage == undefined) {
      const downloadUrl = `https://api.unmix-app.com/api/v1/copyfiles?id=-1&folder=${currentFileid}&file=${filename}&isdemo=0&bucket_id=${is_aws_storage}`;
      window.open(downloadUrl);
    } else {
      const downloadUrl = `https://devapi.unmix-app.com/api/v1/copyfiles?id=-1&folder=${rowData.file_id}&file=${filename}&isdemo=0&bucket_id=${rowData.is_aws_storage}`;
      window.open(downloadUrl);
    }
  };

  const functiongetsong = async (row) => {
    const response1 = await axios1.get(
      "https://devapi.unmix-app.com/api/v1/admin/getsongfiles",
      {
        params: { id: row.file_id, bucket_id: row.is_aws_storage },
      },
    );
    if (response1.data.message == "found") {
      setKaroakeData(response1.data.files.files);
      setCurrentBucket(row.is_aws_storage);
      setCurrentFileid(row.file_id);
      setOpenModal(true);
    } else {
      toast.error("File not present in bucket");
    }
  };

  // ---- Fetch data, now accepts filters ----
  const fetchData = async (currentPage, currentFilters = filters) => {
    setLoading(true);
    try {
      const response = await axios.get(requests.allFeedback1, {
        params: {
          page: currentPage,
          pageSize: pageSize,
          rating: currentFilters.rating,
          platform: currentFilters.platform,
          appversion: currentFilters.appversion,
          country: currentFilters.country,
          language: currentFilters.language,
          fromDate: currentFilters.fromDate,
          toDate: currentFilters.toDate,
          user_id: currentFilters.user_id,
          request_id: currentFilters.requestId,
          requestIdEmpty: currentFilters.requestIdEmpty,
          noteEmpty: currentFilters.noteEmpty,
          aiNoteEmpty: currentFilters.aiNoteEmpty,
          extension: currentFilters.extension,
        },
      });
      if (response.data.Success === 1) {
        setData(response.data.data);
        console.log(response.data.data, "get");

        const rows = response.data.data;
        const filteredRows = rows.filter((row) => row.stems === 4);

        for (const row of filteredRows) {
          // placeholder for future per-row calls if needed
        }
        console.log(response.data, "response");
        setTotalCount(response.data.totalCount);

        // ---- Populate filter dropdown options from API response ----
        if (response.data.filterOptions) {
          setAppVersionOptions(response.data.filterOptions.appVersions || []);
          setCountryOptions(response.data.filterOptions.countries || []);
          setLanguageOptions(response.data.filterOptions.languages || []);
        }
      } else {
        toast.warning(`Something went wrong`, {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchDataSearch = async (searchValue, currentPage) => {
    setLoading(true);
    try {
      const response = await axios.get(requests.filterUsers, {
        params: { page: currentPage, search: searchValue },
      });
      if (response.data.Success === 1) {
        setData(response.data.data);
        setTotalCount(response.data.totalCount);
      } else {
        toast.warning(`Something went wrong`, {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // rows-per-page changed, go back to page 1
  };

  const handleSearch = () => {
    setPage(0);
    if (searchValue === "") {
      fetchData(1, filters);
    } else {
      fetchDataSearch(searchValue, 1);
    }
  };

  // ---- Filter handlers ----
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  // ---- Fetch the extensions actually present for the given rating/date filters ----
  const fetchExtensionsByRating = async ({ rating, fromDate, toDate }) => {
    setLoadingExtensions(true);
    try {
      const response = await axios.get(requests.extensionsByRating, {
        params: { rating, fromDate, toDate },
      });
      if (response.data.Success === 1) {
        setExtensionOptions(response.data.data.extensions || []);
      } else {
        setExtensionOptions([]);
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
      setExtensionOptions([]);
    } finally {
      setLoadingExtensions(false);
    }
  };

  // ---- Narrows the File Type dropdown based on the current rating/date filters ----
  const refreshExtensionOptions = ({ rating, fromDate, toDate }) => {
    if (rating || fromDate || toDate) {
      fetchExtensionsByRating({ rating, fromDate, toDate });
    } else {
      setExtensionOptions(ALLOWED_EXTENSIONS);
    }
  };

  // ---- Rating filter change ----
  const handleRatingChange = (value) => {
    const nextFilters = { ...filters, rating: value, extension: "" };
    setFilters(nextFilters);
    refreshExtensionOptions(nextFilters);
  };

  // ---- From/To Date filter change ----
  const handleFromDateChange = (value) => {
    const nextFilters = { ...filters, fromDate: value, extension: "" };
    setFilters(nextFilters);
    refreshExtensionOptions(nextFilters);
  };

  const handleToDateChange = (value) => {
    const nextFilters = { ...filters, toDate: value, extension: "" };
    setFilters(nextFilters);
    refreshExtensionOptions(nextFilters);
  };

  const applyFilters = () => {
    setPage(0); // reset to first page when filters change
    fetchData(1, filters);
  };

  const clearFilters = () => {
    const emptyFilters = {
      rating: "",
      platform: "",
      appversion: "",
      country: "",
      language: "",
      fromDate: "",
      toDate: "",
      user_id: "",
      requestId: "",
      requestIdEmpty: "",
      noteEmpty: "",
      aiNoteEmpty: "",
      extension: "",
    };
    setFilters(emptyFilters);
    setExtensionOptions(ALLOWED_EXTENSIONS);
    setPage(0);
    fetchData(1, emptyFilters);
  };

  // ---- CSV helpers ----
  const csvEscape = (val) => {
    if (val === null || val === undefined) return "";
    const str = String(val);
    if (/[",\n\r]/.test(str)) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  // Computed/derived values that aren't plain fields on the row
  const getCellValue = (row, col) => {
    if (col.field === "trimmed_computed") {
      const filepath = row.filepath || "";
      const nameOnly = filepath.replace(/\.[^/.]+$/, "");
      const parts = nameOnly.split("_").filter((p) => p !== "");
      return parts.length > 10 ? "Yes" : "No";
    }
    if (col.field === "ai_note_empty_computed") {
      return row.ai_note ? "No" : "Yes";
    }
    return row[col.field];
  };

  // ---- Export ALL filtered records ----
  // Hit allFeedback1 once WITHOUT a `page` param -- the backend already
  // treats a missing page as "return every matching row, unpaginated"
  // (see isPaginated in getfeedback1). One request, one DB query, no
  // looping through pages. Then just convert the result to CSV.
  const exportAllData = async (columnList) => {
    if (exportingAll) return;
    setExportingAll(true);

    const params = {
      rating: filters.rating,
      platform: filters.platform,
      appversion: filters.appversion,
      country: filters.country,
      language: filters.language,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      user_id: filters.user_id,
      request_id: filters.requestId,
      requestIdEmpty: filters.requestIdEmpty,
      noteEmpty: filters.noteEmpty,
      aiNoteEmpty: filters.aiNoteEmpty,
      extension: filters.extension,
    };

    try {
      const response = await axios.get(requests.allFeedback1, { params });

      if (response.data.Success !== 1) {
        toast.warning("Export failed. Could not fetch records.", {
          position: "top-right",
          autoClose: 2500,
        });
        return;
      }

      const rows = response.data.data || [];

      if (rows.length === 0) {
        toast.info("No records match these filters.", {
          position: "top-right",
          autoClose: 2500,
        });
        return;
      }

      // Build CSV lines via array push + single join (no string +=).
      // Only columns that map to real data get exported; action/button
      // columns (Download, Original_File, etc.) are skipped via exportSkip.
      const exportableCols = (columnList || []).filter(
        (col) => col.field && !col.exportSkip,
      );
      const headerLine = exportableCols
        .map((col) => csvEscape(col.title))
        .join(",");

      const lines = [headerLine];
      for (const row of rows) {
        const line = exportableCols
          .map((col) => csvEscape(getCellValue(row, col)))
          .join(",");
        lines.push(line);
      }
      const totalRows = rows.length;

      // single join, BOM so Excel reads UTF-8 correctly
      const blob = new Blob(["\uFEFF" + lines.join("\n")], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `all_feedback_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      toast.success(`Exported ${totalRows} records`, {
        position: "top-right",
        autoClose: 2000,
      });
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setExportingAll(false);
    }
  };

  // ---- Edit Note handlers ----
  const openEditNote = (rowData) => {
    setEditNote({ open: true, id: rowData.id, value: rowData.note || "" });
  };

  const closeEditNote = () => {
    setEditNote({ open: false, id: null, value: "" });
  };

  const handleSaveNote = async () => {
    if (!editNote.id) return;
    setSavingNote(true);
    try {
      const response = await axios.post(requests.updateFeedbackNote, {
        id: editNote.id,
        note: editNote.value,
      });
      if (response.data.Success === 1) {
        // local data update kar do taaki refetch na karna pade
        setData((prevData) =>
          prevData.map((row) =>
            row.id === editNote.id ? { ...row, note: editNote.value } : row,
          ),
        );
        toast.success("Note updated successfully", {
          position: "top-right",
          autoClose: 2000,
        });
        closeEditNote();
      } else {
        toast.warning(response.data.message || "Something went wrong", {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setSavingNote(false);
    }
  };

  // ---- Edit AI Note handlers (Ai Team Feedback) ----
  // NOTE: backend updates audio_info.ai_note by request_id when ai=1 is sent,
  // and request_id corresponds to feedback_for_file.file_id, so we key off file_id here.
  const openEditAiNote = (rowData) => {
    setEditAiNote({
      open: true,
      id: rowData.id,
      value: rowData.ai_note || "",
    });
  };

  const closeEditAiNote = () => {
    setEditAiNote({ open: false, id: null, value: "" });
  };

  const handleSaveAiNote = async () => {
    if (!editAiNote.id) return;
    setSavingAiNote(true);
    try {
      const response = await axios.post(requests.updateFeedbackNote, {
        id: editAiNote.id,
        note: editAiNote.value,
        ai: 1,
      });
      if (response.data.Success === 1) {
        // local data update kar do taaki refetch na karna pade
        setData((prevData) =>
          prevData.map((row) =>
            row.id === editAiNote.id
              ? { ...row, ai_note: editAiNote.value }
              : row,
          ),
        );
        toast.success("Ai Team Feedback updated successfully", {
          position: "top-right",
          autoClose: 2000,
        });
        closeEditAiNote();
      } else {
        toast.warning(response.data.message || "Something went wrong", {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setSavingAiNote(false);
    }
  };

  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
        <Card className="card">
          <Card.Header className="heading">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="inside-header"
            >
              <span>All SEPARATION FEEDBACK</span>
              <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                Total Results: {totalCount}
              </span>
            </div>
          </Card.Header>
          <Card.Body className="body">
            <style>{`
              .mini-spinner {
                display: inline-block;
                width: 16px;
                height: 16px;
                border: 2px solid #ccc;
                border-top-color: #666;
                border-radius: 50%;
                animation: mini-spin 0.6s linear infinite;
              }
              @keyframes mini-spin {
                to { transform: rotate(360deg); }
              }
            `}</style>
            {/* ---- Filter Bar ---- */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "15px",
                alignItems: "center",
              }}
            >
              <TextField
                label="User ID"
                value={filters.user_id}
                onChange={(e) => handleFilterChange("user_id", e.target.value)}
                style={{ minWidth: 120 }}
              />

              <TextField
                label="Request ID"
                value={filters.requestId}
                onChange={(e) =>
                  handleFilterChange("requestId", e.target.value)
                }
                style={{ minWidth: 120 }}
              />

              <TextField
                select
                label="Rating"
                SelectProps={{ native: true }}
                value={filters.rating}
                onChange={(e) => handleRatingChange(e.target.value)}
                style={{ minWidth: 100 }}
              >
                <option value=""></option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </TextField>

              <TextField
                select
                label="Platform"
                SelectProps={{ native: true }}
                value={filters.platform}
                onChange={(e) => handleFilterChange("platform", e.target.value)}
                style={{ minWidth: 120 }}
              >
                <option value=""></option>
                <option value="android">Android</option>
                <option value="ios">iOS</option>
                <option value="webApp">WebApp</option>
                <option value="macOS">MacOs</option>
              </TextField>

              <TextField
                select
                label="App Version"
                SelectProps={{ native: true }}
                value={filters.appversion}
                onChange={(e) =>
                  handleFilterChange("appversion", e.target.value)
                }
                style={{ minWidth: 120 }}
              >
                <option value=""></option>
                {appVersionOptions.map((v, i) => (
                  <option key={i} value={v}>
                    {v}
                  </option>
                ))}
              </TextField>

              <TextField
                select
                label="Country"
                SelectProps={{ native: true }}
                value={filters.country}
                onChange={(e) => handleFilterChange("country", e.target.value)}
                style={{ minWidth: 120 }}
              >
                <option value=""></option>
                {countryOptions.map((c, i) => (
                  <option key={i} value={c}>
                    {c}
                  </option>
                ))}
              </TextField>

              <TextField
                select
                label="Language"
                SelectProps={{ native: true }}
                value={filters.language}
                onChange={(e) => handleFilterChange("language", e.target.value)}
                style={{ minWidth: 120 }}
              >
                <option value=""></option>
                {languageOptions.map((l, i) => (
                  <option key={i} value={l}>
                    {l}
                  </option>
                ))}
              </TextField>

              <TextField
                label="From Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={filters.fromDate}
                onChange={(e) => handleFromDateChange(e.target.value)}
              />

              <TextField
                label="To Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={filters.toDate}
                onChange={(e) => handleToDateChange(e.target.value)}
              />

              {/* ---- Request ID empty filter ---- */}

              {/* ---- Note empty filter ---- */}
              <TextField
                select
                label="Oper. Note Empty"
                SelectProps={{ native: true }}
                value={filters.noteEmpty}
                onChange={(e) =>
                  handleFilterChange("noteEmpty", e.target.value)
                }
                style={{ minWidth: 150 }}
              >
                <option value=""></option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </TextField>

              {/* ---- Ai Note empty filter ---- */}
              <TextField
                select
                label="Ai Note Empty"
                SelectProps={{ native: true }}
                value={filters.aiNoteEmpty}
                onChange={(e) =>
                  handleFilterChange("aiNoteEmpty", e.target.value)
                }
                style={{ minWidth: 150 }}
              >
                <option value=""></option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </TextField>

              {/* ---- File type / extension filter ---- */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <TextField
                  select
                  label="File Type"
                  SelectProps={{ native: true }}
                  value={filters.extension}
                  onChange={(e) =>
                    handleFilterChange("extension", e.target.value)
                  }
                  disabled={loadingExtensions}
                  style={{ minWidth: 130 }}
                >
                  <option value=""></option>
                  {extensionOptions.map((ext, i) => (
                    <option key={i} value={ext}>
                      {ext}
                    </option>
                  ))}
                </TextField>
                {loadingExtensions && <span className="mini-spinner" />}
              </div>

              <Button variant="primary" size="sm" onClick={applyFilters}>
                Apply Filters
              </Button>
              <Button variant="secondary" size="sm" onClick={clearFilters}>
                Clear
              </Button>

              {exportingAll && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "13px",
                  }}
                >
                  <span className="mini-spinner" />
                  Exporting...
                </span>
              )}
            </div>

            {loading ? (
              <Loader margin={"auto"} />
            ) : (
              <MaterialTable
                data={data}
                icons={tableIcons}
                columns={[
                  {
                    title: "#",
                    field: "id",
                    render: (rowData) => rowData.tableData.id + 1,
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      borderLeft: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "user_id",
                    field: "uid",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "Request_id",
                    field: "file_id",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                    render: (rowData) => rowData.file_id || "-",
                  },
                  {
                    title: "Country_code",
                    field: "country_code",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "Language_code",
                    field: "language_code",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },
                  {
                    title: "Stems",
                    field: "stems",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },
                  {
                    title: "Premium",
                    field: "premium",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },
                  {
                    title: "Ratings",
                    field: "ratings",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                    render: (rowData) => (
                      <StarRating rating={rowData.ratings} />
                    ),
                  },
                  {
                    title: "User Feedback",
                    field: "feedback",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },
                  {
                    title: "Operations Feedback",
                    field: "note",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-word",
                      minWidth: 250,
                      maxWidth: 350,
                    },
                    headerStyle: {
                      minWidth: 250,
                      maxWidth: 350,
                    },
                    render: (rowData) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span style={{ flex: 1 }}>{rowData.note || "-"}</span>
                        <Button
                          className="getStartBtn"
                          variant="outline-primary"
                          size="sm"
                          onClick={() => openEditNote(rowData)}
                        >
                          <Edit fontSize="small" />
                        </Button>
                      </div>
                    ),
                  },
                  {
                    title: "Ai Team Feedback",
                    field: "ai_note",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-word",
                      minWidth: 250,
                      maxWidth: 350,
                    },
                    headerStyle: {
                      minWidth: 250,
                      maxWidth: 350,
                    },
                    render: (rowData) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span style={{ flex: 1 }}>
                          {rowData.ai_note ? rowData.ai_note : "-"}
                        </span>
                        <Button
                          className="getStartBtn"
                          variant="outline-primary"
                          size="sm"
                          onClick={() => openEditAiNote(rowData)}
                        >
                          <Edit fontSize="small" />
                        </Button>
                      </div>
                    ),
                  },
                  {
                    title: "Ai Note Empty",
                    field: "ai_note_empty_computed",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                    render: (rowData) => (rowData.ai_note ? "No" : "Yes"),
                  },
                  {
                    title: "Added_date",
                    field: "formatted_date",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },
                  {
                    title: "File_path",
                    field: "filepath",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                  },

                  {
                    title: "Trimmed",
                    field: "trimmed_computed",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                    render: (rowData) => {
                      const filepath = rowData.filepath || "";
                      // extension hatao (.mp3 etc)
                      const nameOnly = filepath.replace(/\.[^/.]+$/, "");
                      // trailing/extra underscores se empty strings hatao
                      const parts = nameOnly.split("_").filter((p) => p !== "");
                      const isTrimmed = parts.length > 10;
                      return isTrimmed ? "Yes" : "No";
                    },
                  },
                  {
                    title: "Original_File",
                    field: "extension",
                    exportSkip: true,
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                    },
                    render: (rowData) => (
                      <div className="btnPopUp">
                        <Button
                          className="getStartBtn"
                          variant="primary"
                          size="md"
                          onClick={() =>
                            handleDownload(
                              rowData,
                              `original_file.${rowData.extension}`,
                            )
                          }
                        >
                          Original_file.{rowData.extension}
                        </Button>
                      </div>
                    ),
                  },
                  {
                    title: "Download",
                    exportSkip: true,
                    render: (rowData) =>
                      rowData.filepath?.startsWith("120") ? (
                        <div className="downloadbtnsingle">
                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() =>
                              handleDownload(rowData, "cutted.mp3")
                            }
                          >
                            org
                          </Button>

                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() => {
                              functiongetsong(rowData);
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      ) : // rowData.id == 852070 ? (
                      //   <div className="downloadbtnsingle">
                      //     <Button
                      //       className="getStartBtn"
                      //       variant="primary"
                      //       size="md"
                      //       onClick={() =>
                      //         handleDownload(rowData, "cutted.mp3")
                      //       }
                      //     >
                      //       org
                      //     </Button>
                      //     <Button
                      //       className="getStartBtn"
                      //       variant="primary"
                      //       size="md"
                      //       onClick={() => {
                      //         functiongetsong(rowData);
                      //       }}
                      //     >
                      //       Download
                      //     </Button>
                      //   </div>
                      // ) : rowData.id == 851320 ? (
                      //   <div className="downloadbtnsingle">
                      //     <Button
                      //       className="getStartBtn"
                      //       variant="primary"
                      //       size="md"
                      //       onClick={() =>
                      //         handleDownload(rowData, "cutted.mp3")
                      //       }
                      //     >
                      //       org
                      //     </Button>
                      //     <Button
                      //       className="getStartBtn"
                      //       variant="primary"
                      //       size="md"
                      //       onClick={() => {
                      //         functiongetsong(rowData);
                      //       }}
                      //     >
                      //       Download
                      //     </Button>
                      //   </div>
                      // )
                      rowData.ratings == 1 && rowData.stems == 2 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "instrumental.mp3")
                              }
                            >
                              <FaMusic />
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 1 && rowData.stems == 4 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              <FaDrum />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 1 && rowData.stems == 5 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              Drums
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "guitar.mp3")
                              }
                            >
                              <PiGuitarFill />
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 1 && rowData.stems == 6 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              Drums
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "guitar.mp3")
                              }
                            >
                              <PiGuitarFill />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "piano.mp3")
                              }
                            >
                              Piano
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 1 && rowData.stems == 120 ? (
                        <div className="downloadbtnsingle">
                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() =>
                              handleDownload(rowData, "cutted.mp3")
                            }
                          >
                            org
                          </Button>
                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() => {
                              functiongetsong(rowData);
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      ) : // 2 ratings
                      rowData.ratings == 2 && rowData.stems == 2 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "instrumental.mp3")
                              }
                            >
                              <FaMusic />
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 2 && rowData.stems == 4 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              <FaDrum />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 2 && rowData.stems == 5 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              Drums
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "guitar.mp3")
                              }
                            >
                              <PiGuitarFill />
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 2 && rowData.stems == 6 ? (
                        <>
                          <div className="btnPopUp">
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "cutted.mp3")
                              }
                            >
                              org
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "vocals.mp3")
                              }
                            >
                              <FaMicrophone />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "drums.mp3")
                              }
                            >
                              Drums
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "bass.mp3")
                              }
                            >
                              <GiGuitarBassHead />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "other.mp3")
                              }
                            >
                              Others
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "guitar.mp3")
                              }
                            >
                              <PiGuitarFill />
                            </Button>
                            <Button
                              className="getStartBtn"
                              variant="primary"
                              size="md"
                              onClick={() =>
                                handleDownload(rowData, "piano.mp3")
                              }
                            >
                              Piano
                            </Button>
                          </div>
                        </>
                      ) : rowData.ratings == 2 && rowData.stems == 120 ? (
                        <div className="downloadbtnsingle">
                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() =>
                              handleDownload(rowData, "cutted.mp3")
                            }
                          >
                            org
                          </Button>
                          <Button
                            className="getStartBtn"
                            variant="primary"
                            size="md"
                            onClick={() => {
                              functiongetsong(rowData);
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      ) : (
                        ""
                      ),
                  },
                ]}
                options={{
                  pageSize: pageSize,
                  paginationType: "normal",
                  showTitle: false,
                  pagination: true,
                  pageSizeOptions: PAGE_SIZE_OPTIONS,
                  tableLayout: "auto",
                  search: false,
                  exportButton: true,
                  exportAllData: true,
                  // Override the built-in CSV export: renderData is only the
                  // current page, so we refetch every filtered record instead.
                  exportCsv: (columnList, renderData) => {
                    exportAllData(columnList);
                  },
                  rowStyle: (rowData, index) => {
                    return {
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                    };
                  },
                }}
                totalCount={totalCount}
                page={page}
                onChangePage={(newPage) => handlePageChange(newPage)}
                onChangeRowsPerPage={(newPageSize) =>
                  handlePageSizeChange(newPageSize)
                }
                localization={{
                  pagination: {
                    labelRowsSelect: "rows",
                    labelDisplayedRows: "{from}-{to} of {count}",
                  },
                }}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
      <Modal isOpen={openmodal} onClose={() => setOpenModal(false)}>
        <h3>File List</h3>
        {karoakeData
          .filter((item) => !item.name?.toLowerCase().endsWith(".json"))
          .map((item) => {
            return (
              <>
                {console.log(item, "item")}
                <Button
                  className="getStartBtn"
                  variant="primary"
                  size="md"
                  onClick={() => handleDownload(item, item.name, currentBucket)}
                >
                  {item.name}
                </Button>
              </>
            );
          })}
      </Modal>

      {/* ---- Edit Note Modal ---- */}
      <Modal isOpen={editNote.open} onClose={closeEditNote}>
        <h3>Edit Note</h3>
        <textarea
          value={editNote.value}
          onChange={(e) =>
            setEditNote((prev) => ({ ...prev, value: e.target.value }))
          }
          rows={4}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
        >
          <Button variant="secondary" size="sm" onClick={closeEditNote}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={handleSaveNote}
            disabled={savingNote}
          >
            {savingNote ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal>

      {/* ---- Edit Ai Team Feedback Modal ---- */}
      <Modal isOpen={editAiNote.open} onClose={closeEditAiNote}>
        <h3>Edit Ai Team Feedback</h3>
        <textarea
          value={editAiNote.value}
          onChange={(e) =>
            setEditAiNote((prev) => ({ ...prev, value: e.target.value }))
          }
          rows={4}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
        >
          <Button variant="secondary" size="sm" onClick={closeEditAiNote}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={handleSaveAiNote}
            disabled={savingAiNote}
          >
            {savingAiNote ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default AllBlogs;
